import { dateSearchParamToString } from '../utils/helpers/searchQuery';
import useSearchQueryParam from './useSearchQueryParam';

function useSearchQueryDateParam(param: string, filter: Date | null) {
  useSearchQueryParam(param, filter ? dateSearchParamToString(filter) : '');
}

export default useSearchQueryDateParam;
